// ./src/pages/RecoverPassword/index.tsx
import React from 'react';

import { CardRecoverPassword } from '@components/index';

import { Container } from './styles';

const RecoverPassword: React.FC = () => {
  return (
    <Container>
      <CardRecoverPassword />
    </Container>
  );
};

export default RecoverPassword;
